import { StatParam, StatResponse } from './../api/StatApi';
import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import Utility from '../../../app/utility';

interface statState {
    statInput: StatParam,
    stats: StatResponse | null,
    selectAllPosition: boolean,
    selectAllSize: boolean,
    selectManualSize: boolean,
    componentTypes: string[],
}

const initialState: statState = {
    statInput: {
        masterAreas: [],
        sizes: [],
        customSizeMin: 0,
        customSizeMax: 0,
        startDate: Utility.DateFormat.format(new Date()),
        endDate:  Utility.DateFormat.format(Utility.addDaysToDate(new Date(), 30)),
        includeOutdated: false,
        includeFixed: false,
        componentType: "Tonnage"
    } as StatParam,
    stats: null,
    selectAllPosition: false,
    selectAllSize: false,
    selectManualSize: false,
    componentTypes: []
}

export const StatSlice = createSlice({
    name: "Stat",
    initialState,
    reducers: {
        setMasterAreas: (state, action: PayloadAction<string[]>) => {
            state.statInput.masterAreas = action.payload;
        },
        setSizes: (state, action: PayloadAction<string[]>) => {
            state.statInput.sizes = action.payload;
        },
        setCustomSizeMin: (state, action: PayloadAction<number>) => {
            state.statInput.customSizeMin = action.payload;
        },
        setCustomSizeMax: (state, action: PayloadAction<number>) => {
            state.statInput.customSizeMax = action.payload;
        },
        setStartDate: (state, action: PayloadAction<string>) => {
            state.statInput.startDate = action.payload;
        },
        setEndDate: (state, action: PayloadAction<string>) => {
            state.statInput.endDate = action.payload;
        },
        setIncludeOutdated: (state, action: PayloadAction<boolean>) => {
            state.statInput.includeOutdated = action.payload;
        },
        setIncludeFixed: (state, action: PayloadAction<boolean>) => {
            state.statInput.includeFixed = action.payload;
        },
        setComponentType: (state, action: PayloadAction<string>) => {
            state.statInput.componentType = action.payload;
        },
        setStats: (state, action: PayloadAction<StatResponse>) => {
            state.stats = action.payload;
        },
        setSelectAllPosition: (state, action: PayloadAction<boolean>) => {
            state.selectAllPosition = action.payload;
        },
        setSelectAllSize: (state, action: PayloadAction<boolean>) => {
            state.selectAllSize = action.payload;
        },
        setSelectManualSize: (state, action: PayloadAction<boolean>) => {
            state.selectManualSize = action.payload;
        },
    }
});

export const statSelector = createSelector(
    (state: RootState) => state.stat,
    (data) => data
);

export const {
    setMasterAreas,
    setSizes,
    setCustomSizeMin,
    setCustomSizeMax,
    setStartDate,
    setEndDate,
    setIncludeOutdated,
    setIncludeFixed,
    setComponentType,
    setStats,
    setSelectAllPosition,
    setSelectAllSize,
    setSelectManualSize
} = StatSlice.actions;

export default StatSlice.reducer;